// export const DEFAULT_MODULE = { title: 'Team', name: 'team', icon: 'mdi-account-group-outline' }
// export const DEFAULT_MODULE = { title: 'Activity', name: 'activity', icon: 'mdi-home-city' }
// export const DEFAULT_MODULE = { title: 'User Settings', name: 'user-settings', icon: 'mdi-account-settings-outline' }

import Cache from "../Utilities/Cache";
import { ROUTE_NAMES } from "./routes";

export const MAIN_MODULES = [
    {
        title: "Quick",
        name: ROUTE_NAMES.WORK,
        icon: "mdi-account",
    },
    {
        title: "Work",
        name: ROUTE_NAMES.WORK,
        icon: "mdi-account",
    },
    {
        title: "Activity",
        name: ROUTE_NAMES.ACTIVITY,
        icon: "mdi-home-city",
    },
    {
        title: "Team",
        name: ROUTE_NAMES.TEAM,
        icon: "mdi-account-group-outline",
    },
    {
        title: "User Settings",
        name: ROUTE_NAMES.SETTINGS,
        icon: "mdi-account-settings-outline",
    },
    {
        title: "Organization",
        name: ROUTE_NAMES.DIVISION,
        icon: "mdi-domain",
    },
    {
        title: "Directory",
        name: ROUTE_NAMES.DIRECTORY,
        icon: "sym_r_group",
    },
    {
        title: "Align",
        name: ROUTE_NAMES.ALIGN,
        icon: "sym_r_checklist",
    },
    {
        title: "Reports",
        name: ROUTE_NAMES.REPORTS,
        icon: "sym_r_finance",
    },
];

const cache = new Cache();

export const getModuleByName = (name) =>
    MAIN_MODULES.find((menu) => menu.name === name);

export const DEFAULT_MODULE =
    getModuleByName(cache.get("active_page")) ?? MAIN_MODULES[1];
export const DEFAULT_PAGE = cache.get("active_page") ?? null;

export const ACTIVITY_TABS = [
    {
        name: "dm",
        text: "DM",
    },
    {
        name: "task",
        text: "Task",
    },
    {
        name: "board",
        text: "Board",
    },
    {
        name: "group",
        text: "Groups",
    },
    {
        name: "topics",
        text: "Topics",
    },
];

export const DIRECTORY_TABS = [
    {
        name: "associations",
        text: "Associations",
    },
];

export const USER_SETTING_OPTIONS = {
    account: {
        name: "account",
        description:
            "Welcome to your profile settings! Here you can update your personal information, manage account preferences, and customize your experience within Kaamfu Workspace. Keep your profile details up to date to ensure seamless communication and access to the features that matter most to you.",
    },
    profile: {
        name: "profile",
        description:
            "With Kaamfu you can leave a profile for every role you occupy. This allows you easily segragate your activities share your work with the people that matter. Everyone signs up with a Personal profile, and then you can add additional personal and professional profiles as you need.",
    },
    identity: {
        name: "identity",
        description:
            "With Kaamfu you can leave a profile for every role you occupy. This allows you easily segragate your activities share your work with the people that matter. Everyone signs up with a Personal profile, and then you can add additional personal and professional profiles as you need.",
    },
    social: {
        name: "social",
        description:
            "With Kaamfu you can leave a profile for every role you occupy. This allows you easily segragate your activities share your work with the people that matter. Everyone signs up with a Personal profile, and then you can add additional personal and professional profiles as you need.",
    },
    organizations: {
        name: "organization",
        description:
            "With Kaamfu you can leave a profile for every role you occupy. This allows you easily segragate your activities share your work with the people that matter. Everyone signs up with a Personal profile, and then you can add additional personal and professional profiles as you need.",
    },
    billing: {
        name: "billing",
        description:
            "With Kaamfu you can leave a profile for every role you occupy. This allows you easily segragate your activities share your work with the people that matter. Everyone signs up with a Personal profile, and then you can add additional personal and professional profiles as you need.",
    },
    security: {
        name: "security",
        description:
            "With Kaamfu you can leave a profile for every role you occupy. This allows you easily segragate your activities share your work with the people that matter. Everyone signs up with a Personal profile, and then you can add additional personal and professional profiles as you need.",
    },
    workday: {
        name: "workday",
        description: "general workday controls",
    },
};

export const NEW_SPACE = [
    {
        title: "Space",
        label: "Common",
        ref: "space",
        expanded: false,
        icon: "sort",
    },
    {
        title: "Website Feedback",
        label: "Website Feedback",
        ref: "feedback",
        expanded: true,
        icon: "rate_review",
    },
    {
        title: "Invoice",
        label: "Invoice",
        ref: "invoice",
        expanded: true,
        icon: "receipt_long",
    },
    {
        title: "Shortcut",
        label: "Shortcut",
        ref: "shortcut",
        expanded: true,
        icon: "link",
    },
    {
        title: "Folder",
        label: "Folder",
        ref: "folder",
        expanded: false,
        icon: "folder",
    },
    {
        title: "File",
        label: "File",
        ref: "file",
        expanded: false,
        icon: "description",
    },
    {
        title: "Process",
        label: "Process",
        ref: "process",
        expanded: true,
        icon: "manage_history",
    },
    {
        title: "Account",
        label: "Account",
        ref: "account",
        expanded: false,
        icon: "request_quote",
    },
    {
        title: "Landing Page",
        label: "Landing Page",
        ref: "landing_page",
        expanded: false,
        icon: "web",
    },
    {
        title: "Form",
        label: "Form",
        ref: "form",
        expanded: false,
        icon: "article",
    },
    {
        title: "Survey",
        label: "Survey",
        ref: "survey",
        expanded: true,
        icon: "checklist",
    },
    {
        title: "Customer",
        label: "Customer",
        ref: "customer",
        expanded: true,
        icon: "groups",
    },
    {
        title: "Proposal",
        label: "Proposal",
        ref: "proposal",
        expanded: true,
        icon: "note_alt",
    },
    {
        title: "Estimate",
        label: "Estimate",
        ref: "estimate",
        expanded: false,
        icon: "calculate",
    },
    {
        title: "Project",
        label: "Project",
        ref: "project",
        expanded: true,
        icon: "edit_calendar",
    },
    {
        title: "Job Post",
        label: "Job Post",
        ref: "job_post",
        expanded: false,
        icon: "business_center",
    },
    {
        title: "Payment",
        label: "Payment",
        ref: "payment",
        expanded: true,
        icon: "payments",
    },
    {
        title: "Schedule",
        label: "Schedule",
        ref: "schedule",
        expanded: false,
        icon: "work_history",
    },
    {
        title: "Contract",
        label: "Contract",
        ref: "contract",
        expanded: false,
        icon: "handshake",
    },
    {
        title: "Workflow",
        label: "Workflow",
        ref: "workflow",
        expanded: false,
        icon: "account_tree",
    },
];

export const MAIN_ACCOUNT_MENU = [
    {
        text: "Add Another Account",
        value: "add",
        icon: "mdi-account-plus-outline",
        variant: "menu_item",
    },
    { text: "Divider", value: "", icon: "", variant: "divider" },
    {
        text: "Settings",
        value: "settings",
        icon: "mdi-account-cog-outline",
        variant: "menu_item",
    },
    {
        text: "Billing",
        value: "billing",
        icon: "mdi-receipt-text-outline",
        variant: "menu_item",
    },
    {
        text: "Help",
        value: "help",
        icon: "mdi-help-circle-outline",
        variant: "menu_item",
    },
    { text: "Divider", value: "", icon: "", variant: "divider" },
    {
        text: "Logout",
        value: "logout",
        icon: "mdi-logout-variant",
        variant: "menu_item",
    },
];

export const WORKSPACE_HOVER_MENU_OPTIONS_GROUP = [
    {
        text: "Get Link",
        value: "get_link",
        icon: "mdi-link",
        variant: "menu_item",
    },
    {
        text: "Delete",
        value: "delete",
        icon: "mdi-delete-outline",
        variant: "menu_item",
    },
    {
        text: "Archive",
        value: "archive",
        icon: "mdi-archive-outline",
        variant: "menu_item",
    },
    {
        text: "Copy",
        value: "copy",
        icon: "mdi-content-copy",
        variant: "menu_item",
    },
];

export const CHAT_OPTIONS_MENU = [
    { value: "item_one", title: "Select One" },
    { value: "item_two", title: "Select Two" },
    { value: "item_three", title: "Select Three" },
];

export const CHAT_HOVER_MENU_ITEMS = [
    { value: "reply-to", text: "Reply To", icon: "reply" },
    { value: "forward", text: "Forward", icon: "forward" },
    { value: "copy", text: "Copy", icon: "content_copy" },
    { value: "options-menu", text: "Options", icon: "more_horiz" },
    // { value: 'select', text: 'Select', icon: 'mdi-checkbox-blank-circle-outline' }
];

export const STORE_SERVICE_OPTIONS = [
    { value: "option_one", text: "Option One" },
    { value: "option_two", text: "Option Two" },
    { value: "option_three", text: "Option Three" },
    { value: "option_four", text: "Option Four" },
];
export const STORE_SELLER_DETAILS = [
    { value: "seller_one", text: "Seller One" },
    { value: "seller_two", text: "Seller Two" },
    { value: "seller_three", text: "Seller Three" },
    { value: "seller_four", text: "Seller Four" },
];
export const STORE_BUDGET = [
    { value: "budget_one", text: "100.00" },
    { value: "budget_two", text: "200.00" },
    { value: "budget_three", text: "300.00" },
    { value: "budget_four", text: "400.00" },
];
export const STORE_DELIVERY_TIME = [
    { value: "delivery_one", text: "1hr" },
    { value: "delivery_two", text: "2hrs" },
    { value: "delivery_three", text: "4hrs" },
    { value: "delivery_four", text: "8hrs" },
];
export const STORE_PROVIDERS = [
    { value: "provider_one", text: "Prospus" },
    { value: "provider_two", text: "Kaamfu" },
    { value: "provider_three", text: "Google" },
    { value: "provider_four", text: "Facebook" },
];

export const RIGHT_DRAWER_MINI_TOOLBAR = [
    {
        label: "Tool 1",
        icon: "mdi-resize",
    },
    {
        label: "Tool 2",
        icon: "mdi-application-array-outline",
    },
    {
        label: "Tool 4",
        icon: "mdi-application-outline",
    },
    {
        label: "Tool 3",
        icon: "mdi-application-brackets-outline",
    },
];

export const WORKSPACE_TEAM_MENU = [
    {
        label: "Profile",
        name: "profile",
        icon: "mdi-card-account-details-outline",
        type: "button",
        variant: "text",
    },
    {
        label: "Chat",
        name: "chat",
        icon: "mdi-message-text-outline",
        type: "button",
        variant: "text",
    },
    {
        label: "Options",
        name: "options",
        icon: "mdi-menu",
        type: "button",
        variant: "text",
    },
    // {
    //     label: 'Pinned', name: 'pinned', icon: 'mdi-pin-outline', type: 'button', variant: 'text',
    // },
];

export const WORKSPACE_HOVER_MENU = {
    tasks: [
        {
            label: "Chat",
            name: "chat",
            icon: "mdi-message-text",
            type: "button",
            variant: "text",
        },
        {
            label: "Add",
            name: "add",
            icon: "mdi-plus",
            type: "button",
            variant: "text",
        },
        // {
        //     label: 'Delete', name: 'delete', icon: 'mdi-close', type: 'button', variant: 'text',
        // },
        // {
        //     label: 'Options', name: 'options', icon: 'mdi-menu', type: 'menu', variant: 'text',
        // },
    ],
    taskitems: {
        spaces: [
            {
                label: "Delete",
                name: "delete",
                icon: "mdi-close-circle-outline",
                type: "button",
                variant: "text",
            },
            {
                label: "Divider",
                name: "",
                icon: "",
                type: "divider",
                variant: "divider",
            },
            {
                label: "Clipboard",
                name: "clipboard",
                icon: "mdi-clipboard-outline",
                type: "button",
                variant: "text",
            },
            {
                label: "Chat",
                name: "chat",
                icon: "mdi-message-reply-text-outline",
                type: "button",
                variant: "text",
            },
            // {
            //     label: 'Options', name: 'options', icon: 'mdi-menu', type: 'menu', variant: 'text',
            // },
        ],
        boards: [
            {
                label: "Delete",
                name: "delete",
                icon: "mdi-close-circle-outline",
                type: "button",
                variant: "text",
            },
            {
                label: "Divider",
                name: "",
                icon: "",
                type: "divider",
                variant: "divider",
            },
            {
                label: "Clipboard",
                name: "clipboard",
                icon: "mdi-clipboard-outline",
                type: "button",
                variant: "text",
            },
            {
                label: "Chat",
                name: "chat",
                icon: "mdi-message-reply-text-outline",
                type: "button",
                variant: "text",
            },
            // {
            //     label: 'Options', name: 'options', icon: 'mdi-menu', type: 'menu', variant: 'text',
            // },
        ],
        items: [
            // { label: 'Edit', name: 'edit', icon: 'mdi-pencil', type: 'button', variant: 'text' },
            {
                label: "Delete",
                name: "delete",
                icon: "mdi-close-circle-outline",
                type: "button",
                variant: "text",
            },
            {
                label: "Divider",
                name: "",
                icon: "",
                type: "divider",
                variant: "divider",
            },
            {
                label: "Clipboard",
                name: "clipboard",
                icon: "mdi-clipboard-outline",
                type: "button",
                variant: "text",
            },
            {
                label: "Document",
                name: "document",
                icon: "mdi-note-text-outline",
                type: "button",
                variant: "text",
            },
            {
                label: "Chat",
                name: "chat",
                icon: "mdi-message-reply-text-outline",
                type: "button",
                variant: "text",
            },
            // {
            //     label: 'Options', name: 'options', icon: 'mdi-menu', type: 'menu', variant: 'text',
            // },
        ],
    },
};

export const CONTROL_SETUP_MODULE = [
    { name: "personal", icon: "", type: "button", variant: "text" },
    { name: "invitation", icon: "", type: "button", variant: "text" },
    { name: "download", icon: "", type: "button", variant: "text" },
    {
        name: "organization",
        icon: "",
        type: "button",
        variant: "text",
        sublist: true,
    },
    { name: "team", icon: "", type: "button", variant: "text" },
    { name: "work", icon: "", type: "button", variant: "text" },
];

export const CONTROL_ORGANIZATION_MODULE = [
    { name: "establish", icon: "", type: "button", variant: "text" },
    { name: "ownership", icon: "", type: "button", variant: "text" },
    { name: "billing-details", icon: "", type: "button", variant: "text" },
    { name: "services", icon: "", type: "button", variant: "text" },
];

export const INVITE_YOUR_TEAM = "invite_your_team";
export const DESIGNATE_WORKSPACE_ADMINS = "designate_workspace_admins";
export const DEFINE_MANDATES_FOR_WORKSTATION_CONNECT =
    "define_mandates_for_workstation_connect";
export const CONFIGURE_WORKDAY_SETTINGS = "configure_workday_settings";
export const ENABLE_ENTERPRISE_SUPPORT = "enable_enterprise_support";
export const BUILD_PROJECTS_IN_THE_WORK_PANEL =
    "build_projects_in_the_work_panel";
export const MANAGE_WORKSPACE_REPORTS = "manage_workspace_reports";
export const CREATE_YOUR_PERSONAL_PROFILE = "create_your_personal_profile";
export const CREATE_AN_ORGANIZATION_PROFILE = "create_an_organization_profile";
export const INSTALL_KAAMFU_WORKSTATION_CONNECT =
    "install_kaamfu_workstation_connect";
export const ACCEPT_INVITATION = "accept_invitation";
export const KNOW_YOUR_KAAMFU = "know_what_you_get_from_kaamfu";
export const MEET_YOUR_KAAMFU_AI = "meet_your_kai";
export const MEET_YOUR_KAAMFU_AI_WORKER = "meet_your_kai_worker";
export const GET_HELP_NOW = "get_help_now";

export const orgOwnerDummyStep = Object.freeze({
    body_text: "",
    button_text: "Show me",
    completion_weight: "14.29",
    created_at: "2025-09-05T12:50:08.000000Z",
    icon_url: "/images/Control/invitation.svg",
    id: 100,
    informational_text: null,
    informational_video: null,
    intro_text: `Once you create an organization, you can invite your team and start collaborating instantly.`,
    is_admin: true,
    is_completed: true,
    is_organization_status_completed: false,
    is_owner: true,
    is_worker: false,
    order: 8,
    organization_status: 0,
    profile_step: null,
    status: true,
    status_text: "No associations formed",
    success_text: null,
    supporting_text:
        "Please complete your organization's details to set up your account.",
    title: "Create An Organization Profile ",
    type: CREATE_AN_ORGANIZATION_PROFILE,
    updated_at: "2025-09-09T05:22:05.000000Z",
    is_dummy: true,
});

export const profileDummyStep = Object.freeze({
    body_text: "",
    button_text: "Show me",
    completion_weight: "14.29",
    created_at: "2025-09-05T12:50:08.000000Z",
    icon_url: "/images/Control/profile.svg",
    id: 99,
    informational_text: null,
    informational_video: null,
    intro_text:
        "Every individual within Kaamfu needs a personal profile to access and use Kaamfu.",
    is_admin: true,
    is_completed: true,
    is_organization_status_completed: false,
    is_owner: true,
    is_worker: false,
    order: 7,
    organization_status: 0,
    profile_step: null,
    status: true,
    status_text: "No associations formed",
    success_text: null,
    supporting_text: "Create your profile by providing your information.",
    title: "Create Your Personal Profile ",
    type: CREATE_YOUR_PERSONAL_PROFILE,
    updated_at: "2025-09-09T05:22:05.000000Z",
    is_dummy: true,
});

export const getDummyOrganizationInvitationStep = (
    organizationName,
    inviterFirstName,
) => {
    return {
        title: `Accept Invitation to Associate With ${organizationName}`,
        type: ACCEPT_INVITATION,
        body_text: "",
        button_text: "Show me",
        completion_weight: "14.29",
        created_at: "2025-09-05T12:50:08.000000Z",
        icon_url: "/images/Control/invitation.svg",
        id: 98,
        informational_text: null,
        informational_video: null,
        intro_text: `Review the invitation from ${inviterFirstName} to associate with ${organizationName} and accept it, if you recognize the inviter or the organization.`,
        is_admin: true,
        is_completed: true,
        is_organization_status_completed: false,
        is_owner: true,
        is_worker: false,
        order: 8,
        organization_status: 0,
        profile_step: null,
        status: true,
        status_text: "No associations formed",
        success_text: null,
        supporting_text: `Review and accept invitation from ${inviterFirstName} to associate with ${organizationName}`,
        updated_at: "2025-09-09T05:22:05.000000Z",
        is_dummy: true,
    };
};

export const MOBILE_ALIGN_ROUTES_STEP_TYPES = Object.freeze({
    [ROUTE_NAMES.MOBILE_CREATE_PERSONAL_PROFILE]: CREATE_YOUR_PERSONAL_PROFILE,
    [ROUTE_NAMES.MOBILE_CREATE_ORGANIZATION]: CREATE_AN_ORGANIZATION_PROFILE,
    [ROUTE_NAMES.MOBILE_INVITE_TEAM]: INVITE_YOUR_TEAM,
    [ROUTE_NAMES.MOBILE_BUILD_PROJECTS]: BUILD_PROJECTS_IN_THE_WORK_PANEL,
    [ROUTE_NAMES.MOBILE_KNOW_KAAMFU]: KNOW_YOUR_KAAMFU,
    [ROUTE_NAMES.MOBILE_GET_HELP]: GET_HELP_NOW,
});

// Reverse the MOBILE_ALIGN_ROUTES_STEP_TYPES object to get the route name from the step type
export const MOBILE_ALIGN_ROUTES = Object.freeze(
    Object.keys(MOBILE_ALIGN_ROUTES_STEP_TYPES).reduce((acc, route) => {
        acc[MOBILE_ALIGN_ROUTES_STEP_TYPES[route]] = route;
        return acc;
    }, {}),
);

export const MOBILE_ANALYTICS_TYPES = {
    BOOK_SESSION_BUTTON_CLICKED_MOBILE: "BOOK_SESSION_BUTTON_CLICKED_MOBILE",
    URL_TRACKING_MOBILE: "URL_TRACKING_MOBILE",
    URL_CONNECT_WITH_MARC_MOBILE: "URL_CONNECT_WITH_MARC_MOBILE",
};

export const LOAD_SCORE_TITLES = {
    1: {
        subCategory: "Severely Underutilized",
        category: "Far Below Capacity",
        definition:
            "Workload is minimal and responsibilities are far below capability. Limited involvement in tasks or oversight. Potential value is significantly underleveraged.",
    },
    2: {
        subCategory: "Far Below Underutilized",
        category: "Far Below Underutilized",
        definition:
            "Workload is consistently light with minimal complexity. Worker is capable of absorbing more scope. Risk of disengagement increases if load does not grow.",
    },
    3: {
        subCategory: "Light Load but Increasing",
        category: "Below Capacity",
        definition:
            "Responsibilities are growing but still below optimal level. Worker has room for additional assignments or broader oversight with little risk of strain.",
    },
    4: {
        subCategory: "Approaching Full Load",
        category: "Below Capacity",
        definition:
            "Workload meets several expected standards but capacity remains meaningfully underused. Can safely take on more, especially in skill variety or downline complexity.",
    },
    5: {
        subCategory: "Stable and Balanced",
        category: "At Capacity",
        definition:
            "Workload is well matched to capability. Worker delivers consistently without overload or idle time. Engagement and utilization are healthy.",
    },
    6: {
        subCategory: "High but Sustainable",
        category: "At Capacity",
        definition:
            "Responsibilities push capability in a productive way. Worker manages diverse tasks and oversight effectively. Top of the optimal load range with strong performance potential.",
    },
    7: {
        subCategory: "Strained but Performing",
        category: "Above Capacity",
        definition:
            "Workload regularly exceeds comfortable limits. Some stress indicators or delays appear. Suitable only for short periods without support or redistribution.",
    },
    8: {
        subCategory: "Overloaded",
        category: "Above Capacity",
        definition:
            "Worker is carrying significantly more responsibilities than can be sustained. Quality, leadership, or wellbeing may be impacted. Requires load reduction or additional help.",
    },
    9: {
        subCategory: "Severely Overloaded",
        category: "Far Above Capacity",
        definition:
            "Performance risk is high due to extreme workload. Critical tasks or oversight may be slipping. Situation demands immediate intervention.",
    },
    10: {
        subCategory: "Critically Overloaded",
        category: "Far Above Capacity",
        definition:
            "Workload far exceeds capacity across all dimensions. Serious risk to outcomes, team health, and worker wellbeing. Urgent rebalancing is required.",
    },
};

export const RESPONSIVENESS_SCORE_TITLES = {
    1: {
        subCategory: "Critically Underperforming",
        category: "Far Below Expectations",
        definition:
            "Frequently unresponsive or uncontactable. Fails to acknowledge messages, tasks, or requests in a timely manner. Patterns of neglect create operational risk and require immediate correction.",
    },
    2: {
        subCategory: "Severely Underperforming",
        category: "Far Below Expectations",
        definition:
            "Consistently slow to respond or acknowledge communication. Regularly delays progress or creates bottlenecks. Requires close supervision and escalation support.",
    },
    3: {
        subCategory: "Developing but Inconsistent",
        category: "Below Expectations",
        definition:
            "Responds intermittently. Occasionally misses important messages or task updates, causing delays. Improvement plan needed to restore dependability.",
    },
    4: {
        subCategory: "Inconsistently Meeting Standards",
        category: "Below Expectations",
        definition:
            "Response times vary significantly. Communicates adequately in some cases but inconsistent follow-through affects coordination. Needs stronger attention discipline.",
    },
    5: {
        subCategory: "Generally Reliable",
        category: "Meets Expectations",
        definition:
            "Responds to most messages and requests within acceptable timeframes. Some variation in speed or prioritization, but overall reliable and cooperative.",
    },
    6: {
        subCategory: "Consistently Reliable",
        category: "Meets Expectations",
        definition:
            "Consistently quick and dependable in communication. Acknowledges tasks and messages promptly, rarely causing workflow disruption. Demonstrates solid engagement habits.",
    },
    7: {
        subCategory: "High Performer",
        category: "Above Expectations",
        definition:
            "Regularly exceeds response expectations. Anticipates requests, replies proactively, and maintains open communication with peers and supervisors.",
    },
    8: {
        subCategory: "Exceptional Performer",
        category: "Above Expectations",
        definition:
            "Exceptionally responsive across all communication channels. Demonstrates initiative in resolving issues before follow-up is required. Helps sustain operational momentum.",
    },
    9: {
        subCategory: "Distinguished Performer",
        category: "Far Above Expectations",
        definition:
            "Consistently immediate and precise responses. Anticipates needs, coordinates smoothly across teams, and prevents bottlenecks before they occur. Often a communication model for others.",
    },
    10: {
        subCategory: "Transformative Performer",
        category: "Far Above Expectations",
        definition:
            "Sets an exemplary standard for responsiveness organization-wide. Operates with near-instant awareness, triaging, and prioritization that elevates overall team performance. Rare and exceptional.",
    },
};
